import React from 'react';
import { format, addMonths } from 'date-fns';
import { useState, useContext, useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { graphqlFindResultsWrapped } from '../../graphql-helpers';
import WaitSpinner from '../../components/wait-spinner';
import FileSaver from 'file-saver';
import { asMoney } from '../../utils';
import {
    Campaign,
    CampaignFinancialLookupQueryVariables,
    useCampaignFinancialLookupQuery
} from '../../generated/graphql';
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import {Accordion, AccordionDetails, AccordionSummary, Button, Switch, FormControlLabel} from "@mui/material";
import { FieldTable } from '../../components/FieldTable/FieldTable';
import {IsoDatePicker} from "../../components/IsoDatePicker";
import {SalesTeamSelect} from "../../components/MaterialSelects/SalesTeamSelect";
import {CampaignStatusSelect} from "../../components/MaterialSelects/CampaignStatusSelect";
import {Download} from "@mui/icons-material";
import { useDaybookContext } from '../../contexts/Daybook/DayBookContext';


const CampaignFinancialReportResults = ({variables,performSearch}) => {
    const {data,loading,error} = useCampaignFinancialLookupQuery({
        variables:variables,
        fetchPolicy:"network-only",
        skip:!performSearch
      });
      const [selectedRows, setSelectedRows] = useState({});
      //const noSel = Object.keys(selectedRows).length === 0;
      const columns:FieldTableColumnProps<Campaign>[] = [
        {
            accessor: 'data.id',
            noSort: true,
            dataType:'selector'
        },{
          accessor:'job_reference',
          header: 'Job Ref',
          dataType:'default'
        },{
          accessor:'name',
          header:'Job Name',
          dataType:'default'
        },{
          accessor:'clientCompany.sales_company',
          header:'Client',
          dataType:'default'
        },{
          accessor:'status',
          header:'Status',
          dataType:'default'
        }
      ];
    const source: {response: Record<string, any>, key: string} = (!loading && !error && data) ? (graphqlFindResultsWrapped(data) as {response: Record<string, any>, key: string}) : {
        response: {results: []},
        key: 'results'
    };
    if(loading) {
        return <WaitSpinner variant="panel"/>;
    }

    const makeExport = ()=> {
        const op = [['ACCOUNT_REF', 'INVOICE_TYPE', 'SERVICE_AMOUNT', 'SERVICE_TEXT', 'STOCK_CODE', 'CUST_ORDER_NUMBER']];
        const data = source.response[source.key];
        data.forEach((val)=>{
            if(selectedRows[val.id]) {
                op.push([
                    val.clientCompany.accounts_account_code,
                    'IS',
                    asMoney(val.total_price),
                    val.job_reference+', '+val.name,
                    'S3',
                    val.purchase_order?val.purchase_order:''
                ]);
            }
        });
        const csv = op.map(e => '"' + e.join('","') + '"').join("\n");
        const file = new Blob([csv], {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(file,'financial-report-'+'.csv');
    }
    let count = 0;
    source.response[source.key].forEach((val)=>{
        if(selectedRows[val.id]) {
            count++;
        }
    });

      const footer= <Button disabled={!count} variant="contained" onClick={makeExport} startIcon={<Download/>}>Download sage export for {count} campaign(s)</Button>;
      return (
        <Accordion defaultExpanded={true}>
          <AccordionSummary>Filtered campaigns</AccordionSummary>
          <AccordionDetails>
          <FieldTable
            className="reports__campaign-financials is-scrollable-sm-h"
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            hasExport={false}
            hasDelete={false}
            footer={footer}
            columns={columns}
            name={source.key}
            values={source.response[source.key]}
            />
          </AccordionDetails>
        </Accordion>
      );
}


const CampaignFinancialReport = () => {
    const [dateFromValue, setDateFromValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [dateToValue, setDateToValue] = useState(format(addMonths(new Date(),1), 'yyyy-MM-dd'));
    // const [excludeInvoiced,setExcludeInvoiced] = useState(true);
    //const [salesTeams,setSalesTeams] = useState([]);
    //const [statuses,setStatuses] = useState([]);
    //const [mutation] = useMutation(CampaignFinancialReport, { fetchPolicy: 'no-cache' });
    const [salesTeams, setSalesTeams] = useState([]);
    const [status,setStatus] = useState(['Confirmed','To Invoice','Part Invoiced']);
    //const [isWait,setWait] = useState(false);
    const toolbarContext = useContext(ToolbarContext);
    const [useCompletionDate, setUseCompletionDate] = useState(true);
    //const [doneSearch,setDoSearch] = useState(false);
    const nightbook = useDaybookContext();
    useEffect(() => {
        toolbarContext.setPrimary(
          {
            primary: [],
            title: 'Campaign Financial Report',
            secondary: []
          });
      }, []);
    function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }

    const updateStatus = (evt)=> {
        console.log('CFIN update status to',evt);
        setStatus([...evt.target.value]);
    }
    const updateSalesTeam = (evt)=> {
        setSalesTeams([...evt.target.value]);
    }
/*    async function submitForm() {
        if (isWait) return;
        //var toastKey = 
        .show({ message: 'Generating report', intent: 'primary',timeout:0 });
        setDoSearch(true);
        setWait(true);
        setWait(true);
        try {
            var data = await mutation({ variables: { date: dateValue, special_announcement: text } });
            setWait(false);
            .show({ message: 'Rendering file', intent: 'success' }, toastKey);
            var res = await fetch(data.data.jobListReport.reportData);
            var blobContent = await res.blob();
            const blobUrl = URL.createObjectURL(blobContent);
            window.open(blobUrl);
        } catch (e) {
            .show({ message: 'Fetch failed', intent: 'danger' }, toastKey);
            setWait(false);
        }
    }*/
    const variables:CampaignFinancialLookupQueryVariables = {};
    if (dateFromValue && dateToValue) {
        if (useCompletionDate) {
            variables.completion_date_between = { from: dateFromValue, to: dateToValue };
        } else {
            variables.start_date_between = { from: dateFromValue, to: dateToValue };
        }
    }    
    /*
    var statuses = [];
    Object.entries(status).forEach(function([,val]) {
        statuses.push(val.id);
    });*/
    if(status.length) {
        variables.status_in = status;
    }

    const varSalesTeams = [];
    Object.entries(salesTeams).forEach(function([,val]) {
        varSalesTeams.push(val.id);
    });

    if(varSalesTeams.length) {
        variables.sales_team_id_in = varSalesTeams;
    }
    return <div><div>
        <Accordion defaultExpanded={true}>
            <AccordionSummary>Campaign Filters</AccordionSummary>
            <AccordionDetails>
        <form method="POST" target="_blank">
            <div className="grid12">
                    <IsoDatePicker name="date" onChange={setDateFrom} value={dateFromValue} allowBlank={true} label="From" className="grid12-4"/>
                    <IsoDatePicker name="date" value={dateToValue} onChange={setDateTo} label="To" className="grid12-4"/>
                    {nightbook?.theme === 'nightbook' && (
                        <FormControlLabel
                            className="grid12-4"
                            control={
                            <Switch
                                checked={useCompletionDate}
                                onChange={(e) => setUseCompletionDate(e.target.checked)}
                            />
                            }
                            label="Filter by Completion Date (toggle off to use Start Date)"
                        />
                    )}
                    <CampaignStatusSelect multiple={true} valueIsId={true} name="status" value={status} onChange={updateStatus} label="Campaign Statuses"/>
                    <SalesTeamSelect multiple={true} name="sales_team" value={salesTeams} onChange={updateSalesTeam} label="Sales Teams"/>
            </div>
        </form>
            </AccordionDetails>
        </Accordion>
        <CampaignFinancialReportResults performSearch={true} variables={variables}/>
</div></div>
}

export default CampaignFinancialReport;